import { FieldOption, FormDataSetConfig } from '@mri/types';

export function assignOptionsToField(formConfig: FormDataSetConfig, key: string, options: FieldOption[]) {
  const field = formConfig.fields.find(f => f.key === key);
  if (!field) return;

  field.options = options;
}
